// extracted by mini-css-extract-plugin
module.exports = {"rectangle":"rectangle_rectangle__2DUWW","inner":"rectangle_inner__ARXlj","iconButton":"rectangle_iconButton__2JMiy","boxShadow":"rectangle_boxShadow__MsZHv"};